import { NumericFormat } from "react-number-format";
import { TextField } from "@mui/material";
import style from "../utils/style";

function FormatNumeric({ label, value, onChange }) {
  return (
    <NumericFormat
      fullWidth
      label={label}
      value={value}
      thousandSeparator=","
      customInput={TextField}
      style={{ marginBottom: 5, marginTop: 8 }}
      onValueChange={({ floatValue }) => {
        onChange(floatValue);
      }}
      sx={style.marginY1}
    />
  );
}

export default FormatNumeric;
